import { css } from 'lit-element'
export default css`
  .tailwind .btn-primary {
    height: 50px;
    width: 100%;
    border-radius: 0.5rem;
    --tw-bg-opacity: 1;
    background-color: rgb(63 47 37 / var(--tw-bg-opacity));
    font-size: 1.125rem;
    line-height: 1.75rem;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }
  @media (hover: hover) and (pointer: fine) {
    .tailwind .btn-primary:hover {
      --tw-bg-opacity: 1;
      background-color: rgb(129 98 78 / var(--tw-bg-opacity));
    }
  }
  .tailwind .btn-primary {
    cursor: pointer;
    border-style: none;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
    transition: background-color 0.3s ease-in-out;
  }
  @media (hover: hover) {
    .tailwind .btn-primary:hover {
      --tw-bg-opacity: 1;
      background-color: rgb(129 98 78 / var(--tw-bg-opacity));
    }
  }
`
